// ============================================================
// Value of the carrier follow-up pilot per month (#111): Jeseník
// parking, fewer no-shows without notice, planner time and message
// costs, against the software price. Numbers come from the demo
// history (last 30 days vs. before the pilot); every assumption says
// whether it is the client's number or our estimate, so it can be
// replaced with OMYA's own figures in the meeting.
// ============================================================

import { history, summarize } from '@/data/statsData';
import { ASSUMPTIONS as URGENCY } from '@/data/urgencyStats';

export const VALUE_ASSUMPTIONS = {
  parkingCostMonth: { value: 200000, source: 'client' },  // Jeseník parking before the pilot, CZK/month
  noShowCost: { value: 500, source: 'estimate' },        // one no-show without notice: idle gate, re-planning, overtime, CZK
  plannerHourCost: { value: 500, source: 'estimate' },   // planner hour incl. overhead, CZK
  softwarePrice: { value: 5000, source: 'offer' },       // our price per month, CZK
};

// { items: [{ key, value, calc, source }], total, roi } in CZK per month.
export function pilotValue(urgency, { noShowCost, softwarePrice } = {}) {
  const a = VALUE_ASSUMPTIONS;
  const k = summarize(history, 30);
  const days = URGENCY.workDaysPerMonth;
  const parkingShare = k.parkingTrucks.before ? 1 - k.parkingTrucks.now / k.parkingTrucks.before : 0;
  const noShowsSaved = Math.max(0, k.noShows.before - k.noShows.now) * days;
  const perNoShow = noShowCost ?? a.noShowCost.value;

  const items = [
    { key: 'parking', value: a.parkingCostMonth.value * parkingShare, source: a.parkingCostMonth.source,
      vars: { before: k.parkingTrucks.before, now: k.parkingTrucks.now, pct: Math.round(parkingShare * 100), cost: a.parkingCostMonth.value } },
    { key: 'noShows', value: noShowsSaved * perNoShow, source: a.noShowCost.source,
      vars: { count: Math.round(noShowsSaved), cost: perNoShow } },
    { key: 'planner', value: urgency.savedHoursMonth * a.plannerHourCost.value, source: a.plannerHourCost.source,
      vars: { hours: urgency.savedHoursMonth, cost: a.plannerHourCost.value } },
    { key: 'messages', value: -urgency.costCzkMonth, source: 'estimate', vars: {} },
  ];
  const total = items.reduce((s, i) => s + i.value, 0);
  const price = softwarePrice ?? a.softwarePrice.value;
  return { items, total, price, roi: price ? total / price : null };
}
